import React from 'react';
import { connect } from 'react-redux';
import { hideModal } from '../../actions/modalActions';
import Modal from '../modalComponent';

function Notification(props: any) {

	const {
		afterClose,
		children
	}: {
		afterClose?: Function,
		children: React.ReactNode
	} = props; 

	const onClose=()=> {
		props.hideModal();

		if (afterClose) {
			afterClose();
		}
	}

	return (
		<Modal onClose={onClose} {...props}>
			{children}
		</Modal>
	);
	
}

export default connect(null, { hideModal })(Notification);
